export default __webpack_public_path__ + "static/media/homeCard.a91b8852.svg";